import {createRouter, createWebHistory} from 'vue-router'
import HomePageOne from '../views/home/HomePageOne'
import HomePageTwo from '../views/home/HomePageTwo'
import HomePageThree from '../views/home/HomePageThree'
import HomePageFour from '../views/home/HomePageFour'
import HomePageFive from '../views/home/HomePageFive'
import HomePageSix from '../views/home/HomePageSix'
import HomePageSeven from '../views/home/HomePageSeven'
import HomePageEight from '../views/home/HomePageEight'
import HomePageNine from '../views/home/HomePageNine'
import HomePageTen from '../views/home/HomePageTen'
import HomePageEleven from '../views/home/HomePageEleven'
import HomePageTwelve from '../views/home/HomePageTwelve'
import CreateProduct from '../views/CreateProduct'
import ProductDetails from '../views/ProductDetails'
import Connect from '../views/Connect'
import Collection from '../views/Collection'
import Creators from '../views/Creators'
import AuthorDetails from '../views/AuthorDetails'
import EditProfilePage from '../views/EditProfilePage'
import About from '../views/About'
import Contact from '../views/Contact'
import BlogDetails from '../views/blog/BlogDetails'
import BlogCategoryPosts from '../views/blog/BlogCategoryPosts'
import BlogTagPosts from '../views/blog/BlogTagPosts'
import BlogSingleColumn from '../views/blog/BlogSingleColumn'
import BlogTwoColumn from '../views/blog/BlogTwoColumn'
import BlogThreeColumn from '../views/blog/BlogThreeColumn'
import BlogThreeColumnTow from '../views/blog/BlogThreeColumn2'
import BlogFourColumn from '../views/blog/BlogFourColumn'
import ExploreOne from '../views/ExploreOne'
import ExploreTwo from '../views/ExploreTwo'
import ExploreThree from '../views/ExploreThree'
import ExploreFour from '../views/ExploreFour'
import ExploreFive from '../views/ExploreFive'
import ExploreSix from '../views/ExploreSix'
import ExploreSeven from '../views/ExploreSeven'
import ExploreEight from '../views/ExploreEight'
import ExploreNine from '../views/ExploreNine'
import ExploreTen from '../views/ExploreTen'
import ExploreEleven from '../views/ExploreEleven'
import ExploreTwelve from '../views/ExploreTwelve'
import ExploreThirteen from '../views/ExploreThirteen'
import ExploreFourteen from '../views/ExploreFourteen'
import UploadVariants from '../views/UploadVariants'
import Activity from '../views/Activity'
import UpcomingProjects from '../views/UpcomingProjects'
import Login from '../views/Login'
import Signup from '../views/Signup'
import ForgetPassword from '../views/ForgetPassword'
import PrivacyPolicy from '../views/PrivacyPolicy'
import Products from '../views/Products'
import Ranking from '../views/Ranking'
import NotFound from '../views/NotFound'
import Support from '../views/Support'
import TermsCondition from '../views/TermsCondition'
import ComingSoon from '../views/ComingSoon'
import Maintenance from '../views/Maintenance'
import Introduction from '../views/introduction.vue'
import YantaiAI from '../views/YantaiAI.vue'

const routes = [
    {
        path: '/',
        name: 'HomePageOne',
        component: HomePageOne,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/introduction',
        name: 'introduction',
        component: Introduction,
    },
    {
        path: '/yantai-ai',
        name: 'YantaiAI',
        component: YantaiAI,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-02',
        name: 'HomePageTwo',
        component: HomePageTwo,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-03',
        name: 'HomePageThree',
        component: HomePageThree,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-04',
        name: 'HomePageFour',
        component: HomePageFour,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-05',
        name: 'HomePageFive',
        component: HomePageFive,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-06',
        name: 'HomePageSix',
        component: HomePageSix,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-07',
        name: 'HomePageSeven',
        component: HomePageSeven,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-08',
        name: 'HomePageEight',
        component: HomePageEight,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-09',
        name: 'HomePageNine',
        component: HomePageNine,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-10',
        name: 'HomePageTen',
        component: HomePageTen,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-11',
        name: 'HomePageEleven',
        component: HomePageEleven,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/index-12',
        name: 'HomePageTwelve',
        component: HomePageTwelve,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/create',
        name: 'CreateProduct',
        component: CreateProduct,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/product/:id',
        name: 'ProductDetails',
        component: ProductDetails,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/connect',
        name: 'Connect',
        component: Connect,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/collection',
        name: 'Collection',
        component: Collection,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/creator',
        name: 'Creators',
        component: Creators,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/author/:id',
        name: 'AuthorDetails',
        component: AuthorDetails,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/edit-profile',
        name: 'EditProfilePage',
        component: EditProfilePage,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/category/:slug',
        name: 'BlogCategoryPosts',
        component: BlogCategoryPosts,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/tag/:slug',
        name: 'BlogTagPosts',
        component: BlogTagPosts,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/blog-details/:id',
        name: 'BlogDetails',
        component: BlogDetails,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/blog-single-column',
        name: 'BlogSingleColumn',
        component: BlogSingleColumn,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/blog-col-two',
        name: 'BlogTwoColumn',
        component: BlogThreeColumnTow,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/blog-col-three',
        name: 'BlogThreeColumn',
        component: BlogThreeColumn,
        meta: {
            title: 'MatrixPower',
        },
    },
 
    {
        path: '/blog',
        name: 'BlogFourColumn',
        component: BlogFourColumn,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-01',
        name: 'ExploreOne',
        component: ExploreOne,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-02',
        name: 'ExploreTwo',
        component: ExploreTwo,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-03',
        name: 'ExploreThree',
        component: ExploreThree,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-04',
        name: 'ExploreFour',
        component: ExploreFour,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-05',
        name: 'ExploreFive',
        component: ExploreFive,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-06',
        name: 'ExploreSix',
        component: ExploreSix,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-07',
        name: 'ExploreSeven',
        component: ExploreSeven,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-08',
        name: 'ExploreEight',
        component: ExploreEight,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-09',
        name: 'ExploreNine',
        component: ExploreNine,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-10',
        name: 'ExploreTen',
        component: ExploreTen,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-11',
        name: 'ExploreEleven',
        component: ExploreEleven,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-12',
        name: 'ExploreTwelve',
        component: ExploreTwelve,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-13',
        name: 'ExploreThirteen',
        component: ExploreThirteen,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/explore-14',
        name: 'ExploreFourteen',
        component: ExploreFourteen,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/upload-variants',
        name: 'UploadVariants',
        component: UploadVariants,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/activity',
        name: 'Activity',
        component: Activity,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/upcoming-projects',
        name: 'UpcomingProjects',
        component: UpcomingProjects,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/sign-up',
        name: 'Signup',
        component: Signup,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/forget',
        name: 'ForgetPassword',
        component: ForgetPassword,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/product',
        name: 'Products',
        component: Products,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/ranking',
        name: 'Ranking',
        component: Ranking,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/404',
        name: 'NotFound',
        component: NotFound,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/support',
        name: 'Support',
        component: Support,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/terms-condition',
        name: 'TermsCondition',
        component: TermsCondition,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/coming-soon',
        name: 'ComingSoon',
        component: ComingSoon,
        meta: {
            title: 'MatrixPower',
        },
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance,
        meta: {
            title: 'MatrixPower',
        },
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
